import {
    IMPORT_USERS_REQUEST,
    IMPORT_USERS_SUCCESS,
    IMPORT_USERS_FAILURE
} from '../actions';


const initialState = {};

const ImportUsersReducer = (state = initialState, action) => {
    switch (action.type) {
        case IMPORT_USERS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case IMPORT_USERS_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case IMPORT_USERS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default ImportUsersReducer;